import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import CustomNavbar from "./components/CustomNavbar";
import ProfileSection from "./components/ProfileSection";
import WorkExperience from "./components/WorkExperience";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button } from "react-bootstrap";

class App extends React.Component {
	// This function gives the location for where to go when click to goToTop button
	topFunction = () => {
		document.body.scrollTop = 0;
		document.documentElement.scrollTop = 0;
	};

	// This function is in charge of when to show goToTop button
	scrollFunction = () => {
		const upBtn = document.getElementById("goToTop");
		upBtn.classList.toggle(
			"active",
			document.body.scrollTop > 400 ||
				document.documentElement.scrollTop > 400
		);
	};

	componentDidMount = () => {
		window.onscroll = this.scrollFunction;
	};

	render() {
		return (
			<div dataspy="scroll" datatarget="#nav-main" dataoffset="0">
				<Button
					variant="primary"
					id="goToTop"
					onClick={this.topFunction}
				>
					<FontAwesomeIcon icon={faArrowUp} />
				</Button>
				<div className="app">
					<CustomNavbar />
					<header className="appHeader">
						<ProfileSection />
					</header>
					<WorkExperience />
					<Projects />
					<Contact />
					<Footer />
				</div>
			</div>
		);
	}
}

export default App;
